// @ts-check

import {
  allDrawingObjects,
  getDrawingObject
} from '../../objects/drawing_object_registry.js?v=20260904f';
import {
  getSelectedDrawingIds,
  getSelectedDrawingObjects
} from '../../selection/drawing_selection_manager.js?v=20260706d';

function cleanId(value) {
  return String(value || '').trim();
}

function explicitGroupIdForObject(object) {
  const metadata = object?.metadata || {};
  return cleanId(
    metadata.connectedGroupId
    || metadata.parentGroupId
    || metadata.groupId
    || metadata.sourceGroupId
    || ''
  );
}

function objectGroupId(object) {
  return explicitGroupIdForObject(object) || cleanId(object?.id);
}

function normalizeObjects(input = null) {
  if (Array.isArray(input)) {
    return input
      .map(entry => (typeof entry === 'string' ? getDrawingObject(entry) : entry))
      .filter(Boolean);
  }
  if (input && typeof input === 'object') return [input].filter(Boolean);
  return getSelectedDrawingObjects();
}

function groupMembersForObject(object) {
  if (!object) return [];
  const explicitGroupId = explicitGroupIdForObject(object);
  if (!explicitGroupId) return [object];
  const systemType = cleanId(object.systemType);
  return allDrawingObjects({ systemType })
    .filter(candidate => explicitGroupIdForObject(candidate) === explicitGroupId);
}

export function resolveGroupIdForDrawingSelection(selection = null) {
  const resolved = resolveGroupSelection2D(selection);
  return resolved?.groupId || null;
}

export function resolveGroupSelection2D(selection = null, options = {}) {
  const candidates = normalizeObjects(selection);
  const primary = candidates[0] || (options.selectedIds ? getDrawingObject(getSelectedDrawingIds()[0]) : null);
  if (!primary) return null;
  const groupId = objectGroupId(primary);
  const members = groupMembersForObject(primary);
  const objects = members.length ? members : [primary];
  return {
    groupId,
    primaryObject: primary,
    objects,
    systemType: cleanId(primary.systemType),
    explicitGroup: Boolean(explicitGroupIdForObject(primary))
  };
}

export function resolveSelectionSet2D(selection = null) {
  return normalizeObjects(selection);
}
